















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";

@Component ({
  components: {}
})
export default class PreenrollmentCopyParagraphs extends Vue {
  @Prop() hsaInvestmentThreshold: number;
  @Prop() partnerName: string;
  formatCurrency = formatCurrency;
}
